import { get, filter, isEmpty, isArray } from 'lodash';

export function datasourceOverrider(field, overrides, datasources, fallback) {
    if (overrides) {
        const [overridingDataSource] = overrides.filter(override => override.label.toLowerCase() === field.toLowerCase());
        if (overridingDataSource && overridingDataSource.dataSourceId) {
            const [matchingDataSource] = datasources.filter(datasource => datasource.id === overridingDataSource.dataSourceId);

            if (matchingDataSource && matchingDataSource.name) {
                return matchingDataSource.name;
            }
        }
    }

    return fallback ? fallback : field;
}

export function getOverride(field, overrides, datasources) {
    if (!overrides || !datasources || !field) return;

    const [overridingDataSource] = overrides.filter(override => override.label.toLowerCase() === field.toLowerCase());
    if (overridingDataSource && overridingDataSource.dataSourceId) {
        const [matchingDataSource] = datasources.filter(datasource => datasource.id === overridingDataSource.dataSourceId);

        if (matchingDataSource && matchingDataSource.name) {
            return matchingDataSource;
        }
    }

    return null;
}

export function getOverriderNoDefault(field, overrides, datasources) {
    if (overrides) {
        const [overridingDataSource] = overrides.filter(override => override.label.toLowerCase() === field.toLowerCase());
        if (overridingDataSource && overridingDataSource.dataSourceId) {
            const [matchingDataSource] = datasources.filter(datasource => datasource.id === overridingDataSource.dataSourceId);

            if (matchingDataSource && matchingDataSource.name) {
                return matchingDataSource.name;
            }
        }
    }
}

export function getStudyDetailFromOverride(field, overrides, datasources, studyDetails) {
    const override = getOverride(field, overrides, datasources);
    if (override) {
        const [detail] = studyDetails.filter(detail => detail.dataSourceId === override.id);
        if (detail) {
            return {
                ...detail,
                isStudyDetails: true,
                label: detail.name,
                placeholder: `Select ${detail.name}`,
                options: override.parameters && override.parameters.values ? override.parameters.values.map(el => ({ ...el, chipLabel: el.text })) : [],
                showCreateField: true
            };
        }

        return {
            ...override,
            isStudyDetails: false,
            options: override.parameters && override.parameters.values ? override.parameters.values.map(el => ({ ...el, chipLabel: el.text })) : [],
            placeholder: `Select ${override.name}`,
            inputFieldType: 'single-select',
            showCreateField: true,
            label: override.name,
            dataSourceId: override.id || '',
            shouldBeAllValuesSelected: false,
            instructions: 'Select a value',
            name: override.name || ''
        };
    }

    return {
        isStudyDetails: false,
        options: [],
        placeholder: '',
        inputFieldType: '',
        showCreateField: false,
        label: '',
        dataSourceId: '',
        shouldBeAllValuesSelected: false,
        instructions: ''
    };

}

export function getValue(selector, isDetail, study, override) {
    if (isDetail) {
        const data = get(study, 'fields.studyDetails', null);
        const dataStudyEssentials = get(study, 'fields.studyEssentials', null);
        if (!data || !dataStudyEssentials) return;
        let field;
        let fieldOldDrafts;
        if (selector === 'Sponsor') {
            [field] = filter(
                data,
                essential => essential.name === override
            );
            [fieldOldDrafts] = filter(
                dataStudyEssentials,
                essential => essential.name === 'sponsorCro'
            );

            if (field && isArray(field.value) && !isEmpty(field.value)) {
                return field.value;
            } else if (field && field.value && field.value.value && field.inputFieldType === 'multi-select') {
                return [field.value];
            }
            else if (field && field.value && field.value.value) {
                return field.value.value;
            } else if (fieldOldDrafts) {
                return fieldOldDrafts.value;
            }
        }
        if (selector === 'Protocol Number / Trial id') {

            [field] = filter(
                data,
                essential => essential.name === override
            );
            [fieldOldDrafts] =
                filter(
                    dataStudyEssentials,
                    essential => essential.name === 'trialId'
                );

            if (field && isArray(field.value)) {
                return field.value;
            } else if (field && field.value && field.value.value) {
                return field.value.value;
            } else if (fieldOldDrafts) {
                return fieldOldDrafts.value;
            }

        }

    } else {
        const data = get(study, 'fields.studyEssentials', []);
        let field;
        if (selector === 'Sponsor') {
            [field] = filter(
                data,
                essential => essential.name === selector.toLowerCase() || essential.name === 'sponsorCro' || essential.name === 'sponsor'
            );
            return field && field.value;
        }
        if (selector === 'Protocol Number / Trial id') {
            [field] = filter(
                data,
                essential => essential.name === selector.toLowerCase() || essential.name === 'trialId'
            );
            return field && field.value;
        }
        [field] = filter(
            data,
            essential => essential.name === selector.toLowerCase()
        );
        return field && field.value;
    }

}